import { Card } from "antd";
import React from "react";

export const SeasonsPage: React.FC = () => {
  return <Card title="Sezone"></Card>;
};
